import type { Localization } from '@/app/components/search/common/Localization.ts';

const SPLIT_PAYMENTS_MIN_PRICE = 50;
const SPLIT_PAYMENTS_MAX_PRICE_DP = 2000;
const SPLIT_PAYMENTS_MAX_PRICE_HO = 1000;

type SplitPaymentsParams = {
  localization: Localization;
  totalPrice: number | undefined;
  isHO: boolean;
};

export const isSplitPaymentsEligible = ({ localization, totalPrice, isHO }: SplitPaymentsParams): boolean => {
  if (!localization?.configValuesApp?.splitPaymentsEnabled || !totalPrice) return false;
  const maxPrice = isHO ? SPLIT_PAYMENTS_MAX_PRICE_HO : SPLIT_PAYMENTS_MAX_PRICE_DP;
  return totalPrice >= SPLIT_PAYMENTS_MIN_PRICE && totalPrice <= maxPrice;
};

export const hasPaymentInfo = ({
  deferredPaymentDeposit,
  localization,
  totalPrice,
  isHO,
}: SplitPaymentsParams & { deferredPaymentDeposit: number | undefined }): boolean =>
  !!deferredPaymentDeposit || isSplitPaymentsEligible({ localization, totalPrice, isHO });
